import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, ChevronUp } from "lucide-react";

const About = () => {
  const [open, setOpen] = useState(false);

  return (
    <section
  id="about"
  className="relative py-10 md:py-20 px-6 bg-gradient-to-b from-[#FFF9F7] via-[#FFF5F2] to-[#FFFFFF] overflow-hidden"
>
      {/* 🌸 Decorative Background Pattern */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 1L12 23M1 12L23 12' stroke='%23FF8A65' stroke-width='0.4'/%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat",
        }}
      />

      {/* 🌈 Soft Gradient Blobs */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-[#FFC4B2]/40 blur-[100px] rounded-full opacity-50" />
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#58B09C]/30 blur-[100px] rounded-full opacity-40" />

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        {/* Heading */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-5xl font-extrabold text-[#333] mb-6 md:mb-8 leading-tight px-2"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          Tentang{" "}
          <span className="text-[#FF8A65]">Toyibah Aqiqah</span>
        </motion.h2>

        {/* 🟠 Mobile Dropdown (Hidden on Desktop) */}
        <div className="block md:hidden">
          <button
            onClick={() => setOpen(!open)}
            className="flex items-center justify-center gap-2 bg-gradient-to-br from-[#FF8A65] to-[#FF6B4A] text-white px-5 py-2 rounded-full mx-auto font-semibold shadow-md hover:scale-105 transition-all"
          >
            {open ? "Tutup Deskripsi" : "Lihat Selengkapnya"}
            {open ? (
              <ChevronUp className="w-4 h-4" />
            ) : (
              <ChevronDown className="w-4 h-4" />
            )}
          </button>

          {/* Animated Expandable Text */}
          <AnimatePresence>
            {open && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.4, ease: "easeInOut" }}
                className="overflow-hidden mt-5"
              >
                <p className="text-[#777] text-base leading-relaxed mb-4">
  <strong>Toyibah Aqiqah</strong> hadir sebagai sahabat keluarga muslim dalam menjalankan ibadah aqiqah dengan penuh ketulusan. 
  Setiap proses kami jalankan dengan niat ibadah, dari pemilihan hewan terbaik, penyembelihan sesuai syariat, hingga penyajian 
  masakan yang higienis dan bercita rasa istimewa. 
</p>

<p className="text-[#777] text-base leading-relaxed">
  Layanan kami menjangkau seluruh wilayah 
  <strong> Jakarta, Bogor, Depok, Tangerang, dan Bekasi (Jabodetabek)</strong>, 
  dengan komitmen untuk menghadirkan <strong>kualitas rasa, kehalalan, dan pelayanan terbaik</strong>. 
  Dengan pengalaman bertahun-tahun, kami berupaya membantu Ayah dan Bunda mewujudkan momen aqiqah yang berkesan, 
  penuh keberkahan, dan membawa kebahagiaan bagi keluarga tercinta.
</p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* 🟢 Desktop Static Text */}
        <div className="hidden md:block">
          <motion.p
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="text-[#777] text-base md:text-lg mb-6 leading-relaxed max-w-3xl mx-auto"
          >
            <strong>Toyibah Aqiqah</strong> hadir sebagai mitra terpercaya bagi
            keluarga muslim yang ingin melaksanakan ibadah aqiqah dengan cara
            <strong> syar’i, higienis, dan penuh keberkahan.</strong> Kami
            menyediakan layanan aqiqah lengkap, mulai dari pemilihan hewan,
            penyembelihan, pengolahan, hingga pengantaran ke rumah Anda.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="text-[#777] text-base md:text-lg leading-relaxed max-w-3xl mx-auto"
          >
            Kami melayani seluruh wilayah{" "}
            <strong>Jakarta, Bogor, Depok, Tangerang, dan Bekasi (JABODETABEK)</strong>{" "}
            dengan komitmen pada <strong>kualitas rasa, pelayanan cepat, dan
            kehalalan 100%</strong>. Dengan pengalaman bertahun-tahun, kami
            membantu Ayah & Bunda mewujudkan momen aqiqah yang istimewa dan
            bermakna.
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default About;
